export const sortByTranslatedLabel = (
    t: (key: string) => string,
    items: Array<{ label: string }>
) => items.sort((a, b) => t(a.label).localeCompare(t(b.label)));

export const sortWithPriority = (
    t: (key: string) => string,
    items: Array<{ label: string; value: string }>,
    topItem: string[] = [],
    bottomItem: string[] = []
) => {
    const top = items.filter((item) => topItem.includes(item.label));
    const bottom = items.filter((item) => bottomItem.includes(item.label));

    const middle = items.filter(
        (item) => !topItem.includes(item.label) && !bottomItem.includes(item.label)
    );

    return [...top, ...sortByTranslatedLabel(t, middle), ...bottom];
};
